import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

const getStyles = () => ({
  facebookImportDialogStepFBConnect: {
    left: '50%',
    position: 'relative',
    transform: 'translate(-50%, 0px)',
  },
  fbConnectSection: {
    height: 112,
    background: '#FFFFFF',
    lineHeight: '100px',
    textAlign: 'center',
    marginBottom: 24,
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    padding: 25,
  },
  fbConnectIcon: {
    color: '#1877F2',
    fontSize: 32,
    lineHeight: '32px',
    left: '50%',
    transform: 'translate(-50%, 0)',
    position: 'relative',
    fontFamily: 'MsAds MDL2 Assets',
    '&:before': {
      content: '"\\ECB3"',
    },
  },
  fbConnectTips: {
    marginTop: 10,
    height: 24,
    lineHeight: '24px',
  },
});

const UnStyledFacebookImportDialogStepFBConnect = ({
  i18n,
  classes,
  onConnectClick,
}) => (
  <div id="facebook-import-dialog-step-fb-connect" className={classes.facebookImportDialogStepFBConnect}>
    <div
      className={classNames(classes.fbConnectSection, classes.fbConnected)}
      onClick={onConnectClick}
      onKeyPress={onConnectClick}
      role="button"
      tabIndex="0"
    >
      <div className={classes.fbConnectIcon} />
      <div className={classes.fbConnectTips}>
        {i18n.getString(_TL_('Connect Facebook page'))}
      </div>
    </div>
    <div className={classes.tipsSection}>
      {i18n.getString(_TL_('You do not have any connected Facebook profile. Connect to your Facebook account to proceed. Your account will not be added to DMC social management.'))}
    </div>
  </div>
);

UnStyledFacebookImportDialogStepFBConnect.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  classes: PropTypes.shape({
    itemContainer: PropTypes.string,
  }).isRequired,
  onConnectClick: PropTypes.func.isRequired,
};

export const FacebookImportDialogStepFBConnect = withDefaultStyles(
  withI18nConsumer(UnStyledFacebookImportDialogStepFBConnect),
  getStyles
);
